import { TPagination } from "./types";

export const DEFAULT_TABLE_HEIGHT_VH = 56;

export const DEFAULT_PAGINATION: TPagination = {
  currentPage: 1,
  itemPerPage: 10,
  totalItem: 0,
  perPageOptions: [10, 25, 50, 100],
};
